<template>
  <div class="flex flex-center" :class="[loadClass]">
    <div class="box-style load-style">
      <ul class="load-icon">
        <li class="load-icon-item"></li>
        <li class="load-icon-item"></li>
        <li class="load-icon-item"></li>
        <li class="load-icon-item"></li>
        <li class="load-icon-item"></li>
        <li class="load-icon-item"></li>
      </ul>
      <div class="load-box">{{ loadtext }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    loadtext: {
      type: String,
      default: '加载中'
    },
    loadtype: {
      type: String,
      default: '1'
    }
  },
  computed: {
    loadClass () {
      return 'alert-content-' + this.loadtype
    }
  }
}
</script>

<style scoped>
.alert-content-1 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.alert-content-2 {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .3);
}
.box-style {
  padding: .15rem;
  box-shadow: 0 .1rem .5rem rgba(0, 0, 0, .2);
  text-align: center;
  background-color: rgba(255, 255, 255, .8);
  font-size: .28rem;
  color: #333;
}
.load-style {
  min-width: 2rem;
  border-radius: .2rem;
}
.load-icon {
  position: relative;
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 1rem;
  height: 1.25rem;
  margin: auto;
}
.load-icon .load-icon-item {
  position: relative;
  list-style: none;
  width: 3px;
  height: .2rem;
  background-color: #666;
}
.load-icon .load-icon-item {
  animation: loadAni .7s infinite alternate;
}
@keyframes loadAni {
  0% {
    transform: scaleY(1);
  }
  25% {
    transform: scaleY(1);
  }
  50% {
    transform: scaleY(1);
  }
  75% {
    transform: scaleY(1);
  }
  100% {
    transform: scaleY(3);
  }
}
.load-icon .load-icon-item:nth-child(1) {
  animation-delay: .1s;
}
.load-icon .load-icon-item:nth-child(2) {
  animation-delay: .2s;
}
.load-icon .load-icon-item:nth-child(3) {
  animation-delay: .3s;
}
.load-icon .load-icon-item:nth-child(4) {
  animation-delay: .4s;
}
.load-icon .load-icon-item:nth-child(5) {
  animation-delay: .5s;
}
.load-icon .load-icon-item:nth-child(6) {
  animation-delay: .6s;
}
</style>
